import React, { useState, useEffect, useRef } from "react";
import { Row, Col, Card, Typography, message, Divider, Table, Space, Button, Select, Form } from "antd";
import { ReadOutlined, BarChartOutlined, UnorderedListOutlined, PrinterOutlined } from "@ant-design/icons";
import { HeaderPage } from "../../../components/headerPage";
import { HeaderTitle } from "../../../components/headerTitle";
import { useNavigate, useParams } from "react-router-dom";
import http from "../../../services/http";
import { TableCustom } from "../../../components/table";
import { parseToInt } from "../../../helpers/masks";
import ReactEcharts from "echarts-for-react";
import { PrintContent } from "./components/print";
import { useReactToPrint } from "react-to-print";

const { Text } = Typography;

export const TreinamentosRelatorio = () => {
  const { id_grupo, id_curso } = useParams();
  const navigate = useNavigate();
  const [dadosGraficos, setDadosGraficos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [dados, setDados] = useState([]);
  const refPrint = useRef(null);
  const [filiais, setFiliais] = useState([]);
  const [formFilter] = Form.useForm();

  // DADOS
  const [curso, setCurso] = useState({});

  useEffect(() => {
    listarFiliais();
    if (id_curso > 0) {
      carregarCurso(id_curso);
    }
  }, [id_curso]);

  useEffect(() => {
    formFilter.setFieldsValue({
      id_cad_filiais: 999,
    });

    formFilter.submit();
  }, []);

  // LISTAR
  const listarFiliais = async () => {
    setLoading(true);
    const api = await http("get", `v1/filiais/listar_ativos`, []);
    if (api.statusCode === 200) {
      const response = api?.response?.data;
      const array_filiais = [{ value: 999, label: "Todas" }];

      for (let index = 0; index < response?.length; index++) {
        array_filiais.push({
          value: response[index]?.id,
          label: `${response[index]?.id} - ${response[index]?.descricao}`,
        });
      }

      setFiliais(array_filiais);
    } else {
      navigate("/pesquisa-satisfacao/formularios");
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // CARREGAR
  const carregarCurso = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("get", `v1/treinamentos_cursos/carregar/${id}`, []);
    if (api.statusCode === 200) {
      const response = api?.response?.data;
      setCurso(response);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // LISTAR
  const listarRelatorio = async (id, id_cad_filiais = 999) => {
    if (!id) return;
    setLoading(true);
    const api = await http("get", `v1/treinamentos_cursos/relatorio/${id}?id_cad_filiais=${id_cad_filiais}`, []);
    if (api.statusCode === 200) {
      const response = api?.response?.data;
      setDados(response);

      let concluidos = 0;
      let nao_concluidos = 0;
      let em_andamento = 0;
      let nao_iniciados = 0;

      for (let index = 0; index < response?.length; index++) {
        concluidos += parseToInt(response[index]?.concluidos);
        nao_concluidos += parseToInt(response[index]?.nao_concluidos);
        em_andamento += parseToInt(response[index]?.em_andamento);
        nao_iniciados += parseToInt(response[index]?.nao_iniciados);
      }

      setDadosGraficos([
        {
          value: concluidos,
          name: "Concluídos",
        },
        {
          value: nao_concluidos,
          name: "Não Aprovados",
        },
        {
          value: em_andamento,
          name: "Em Andamento",
        },
        {
          value: nao_iniciados,
          name: "Não Iniciados",
        },
      ]);
    } else {
      navigate("/treinamentos/grupos");
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // BAIXAR RELATÓRIO PRESENÇA
  const carregarRelatorioCompleto = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("file", `v1/treinamentos_cursos/relatorio_completo/${id}`, []);

    if (api.statusCode === 200) {
      // DOWNLOAD FILE
      const url = window.URL.createObjectURL(api?.response?.data);
      let a = document.createElement("a");
      a.href = url;
      a.download = "relatorio.pdf";
      a.click();
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // COLUNAS TABLE
  const columns = [
    {
      title: "Filial",
      dataIndex: "filial",
    },
    {
      title: "Concluídos",
      dataIndex: "concluidos",
    },
    {
      title: "Não Aprovados",
      dataIndex: "nao_concluidos",
    },
    {
      title: "Em Andamento",
      dataIndex: "em_andamento",
    },
    {
      title: "Não Iniciados",
      dataIndex: "nao_iniciados",
    },
    {
      title: "Total",
      dataIndex: "total",
    },
    {
      title: "",
      width: 50,
      sorter: false,
      render: (_, e) => (
        <Space.Compact>
          <Button
            loading={loading}
            onClick={() => navigate(`/treinamentos/grupos/cursos/${id_grupo}/relatorio/${id_curso}/detalhes/${e?.id}`)}
            icon={<UnorderedListOutlined />}
          />
        </Space.Compact>
      ),
      dataIndex: "acoes",
    },
  ];

  const graphic = (
    <ReactEcharts
      style={{ width: "100%", minHeight: 500 }}
      option={{
        tooltip: {
          trigger: "item",
        },
        legend: {
          orient: "horizontal",
          left: "center",
        },
        series: [
          {
            name: "Alternativas",
            type: "pie",
            radius: ["40%", "70%"],
            avoidLabelOverlap: false,
            label: {
              show: true,
              position: "outside",
              formatter: "{d}%",
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 20,
                fontWeight: "bold",
              },
            },
            labelLine: {
              show: true,
            },
            data: dadosGraficos,
          },
        ],
      }}
    />
  );

  const handlePrint = useReactToPrint({
    content: () => refPrint.current,
  });

  const onSubmitFilter = (values) => {
    if (id_curso > 0) {
      listarRelatorio(id_curso, values?.id_cad_filiais);
    }
  };

  return (
    <Row align="middle" justify="center" className="content-row">
      <Col span={24} align="middle" justify="center">
        <Col xs={24} sm={24} md={22} lg={22} xl={20} xxl={16} align="left">
          <div className="content-item">
            <HeaderPage
              title="Treinamentos & Desenvolvimento"
              onClickBack={() => navigate(`/treinamentos/grupos/cursos/${id_grupo}`)}
            />
            <HeaderTitle
              title={["Treinamentos & Desenvolvimento", "Relatórios"]}
              subtitle={
                <Text italic>
                  <ReadOutlined /> {curso?.descricao ?? ""}
                </Text>
              }
              icon={<BarChartOutlined />}
              loading={loading}
            />
            <Divider />
            <Card bordered={false} bodyStyle={{ padding: "3%" }}>
              <Space direction="vertical" style={{ width: "100%" }} size={20}>
                <TableCustom
                  loading={loading}
                  columns={columns}
                  dataSource={dados}
                  extraHeaderComponents={
                    <Form onFinish={onSubmitFilter} form={formFilter} autoComplete="off">
                      <Space wrap style={{ alignItems: "end", width: "100%" }}>
                        <Space direction="vertical" size={0}>
                          <Text style={{ fontSize: 12 }} type="secondary">
                            Filial:
                          </Text>
                          <Form.Item
                            className="form-item-filter"
                            name="id_cad_filiais"
                            rules={[{ required: true, message: "" }]}>
                            <Select
                              onChange={() => formFilter.submit()}
                              placeholder="Filial"
                              options={filiais}
                              style={{ width: 180, maxWidth: "100%" }}
                              showSearch
                              filterOption={(input, option) =>
                                (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
                              }
                            />
                          </Form.Item>
                        </Space>
                        <Button onClick={handlePrint} icon={<PrinterOutlined />}>
                          Imprimir
                        </Button>
                        <Button
                          onClick={() =>
                            navigate(`/treinamentos/grupos/cursos/${id_grupo}/relatorio-completo/${id_curso}`)
                          }>
                          Relatório Completo
                        </Button>
                      </Space>
                    </Form>
                  }
                  summary={() => {
                    let t_total = 0;
                    let t_concluidos = 0;
                    let t_nao_concluidos = 0;
                    let t_em_andamento = 0;
                    let t_nao_iniciados = 0;

                    dados?.forEach(({ total, concluidos, nao_concluidos, em_andamento, nao_iniciados }) => {
                      t_total += parseInt(total);
                      t_concluidos += parseInt(concluidos);
                      t_nao_concluidos += parseInt(nao_concluidos);
                      t_em_andamento += parseInt(em_andamento);
                      t_nao_iniciados += parseInt(nao_iniciados);
                    });

                    return (
                      <Table.Summary.Row style={{ backgroundColor: "#f7f7f7" }}>
                        <Table.Summary.Cell index={0}>
                          <Text strong>Total</Text>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell index={2}>
                          <Text strong>{t_concluidos}</Text>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell index={2}>
                          <Text strong>{t_nao_concluidos}</Text>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell index={3}>
                          <Text strong>{t_em_andamento}</Text>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell index={4}>
                          <Text strong>{t_nao_iniciados}</Text>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell index={1}>
                          <Text strong>{t_total}</Text>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell index={1} />
                      </Table.Summary.Row>
                    );
                  }}
                />
                <div ref={refPrint}>
                  <PrintContent
                    title={`Treinamentos & Desenvolvimento`}
                    subtitle={`Relatório de Andamento do Curso/Treinamento ${curso?.descricao ?? ""}`}
                    colunas={columns}
                    dados={dados}
                  />
                  <div className="nonbreak">{graphic}</div>
                </div>
              </Space>
            </Card>
          </div>
        </Col>
      </Col>
    </Row>
  );
};
